import PageContainer from "@/pages/containers/page-container";
import { HcbbBackButton } from "@/pages/components/hcbb-cost-estimator/hcbb-back-button";
import { HcbbSearchForm } from "@/pages/components/hcbb-cost-estimator/hcbb-search-form";
import { HcbbSearchResults } from "@/pages/components/hcbb-cost-estimator/hcbb-search-results";
import { HCBB_COST_ESTIMATOR_PATH } from "@/lib/hcbb-cost-estimator-utils";
import { useHcbbCommittedSearch } from "@/hooks/use-hcbb-cost-estimator";
import { useFeatureName } from "@/hooks/use-pageTitle";
import ScreenRouteNames from "@/constants/screen-route-names";

export const HcbbCostEstimatorResultPage = () => {
  // The nested results path has no feature of its own, so title off the parent.
  const featureName = useFeatureName(ScreenRouteNames.HCBB_COST_ESTIMATOR.path);
  const { procedure, targetLocation, distance } = useHcbbCommittedSearch();

  return (
    <PageContainer
      headerLeftContent={<HcbbBackButton to={HCBB_COST_ESTIMATOR_PATH} />}
      title={`${featureName} Results`}
    >
      <div className="space-y-8 p-6">
        <HcbbSearchForm showAdvancedSearch />
        <HcbbSearchResults
          procedure={procedure}
          targetLocation={targetLocation}
          distance={distance}
        />
      </div>
    </PageContainer>
  );
};
